/**
 * Constants for cargo operation types used throughout stowage planning.
 */
export const OperationType = {
    LOADING: 'Loading',
    UNLOADING: 'Unloading',
    TRANSIT: 'Transit',
    TRANSFER: 'Transfer',
} as const;

/** Type representing valid operation type values */
export type OperationTypeValue = (typeof OperationType)[keyof typeof OperationType];

/**
 * Type alias for Loading/Unloading operations only (excludes Transit/Transfer)
 * Used in weight calculation functions that only apply to loading/unloading
 */
export type LoadUnloadOperationType = typeof OperationType.LOADING | typeof OperationType.UNLOADING;
